export default __webpack_public_path__ + "static/media/blueInformation.39100d9c.svg";